import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'react-bootstrap'
import classnames from 'classnames'
import { Flex, Text } from '@leverege/ui-elements'

import { GeotileActions, BreadcrumbActions } from '~/actions'
import GeotileThumbnail from './GeotileThumbnail'
import { Screen, YesNoDialog } from '~/views'
import style from './style.css'

class GeotilesScreen extends React.Component {
  constructor( props, context ) {
    super( props, context )
    this.state = {
      showDialog : false,
      deleteTile : null
    }
  }

  componentDidMount() {
    const { dispatch } = this.props
    this.fetchTileList()
    dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Geotiles' } ] ) )
  }

  fetchTileList() {
    const { dispatch, projectId } = this.props
    dispatch( GeotileActions.list( { projectId } ) )
  }

  onCreateTile = () => {
    const { history, dispatch, projectId } = this.props
    dispatch( GeotileActions.create( { projectId, history } ) )
  }

  onClickTile = ( geotile ) => {
    const { history } = this.props
    history.push( `geotile/${geotile.id}` )
  }

  onDeleteClick = ( geotile ) => {
    this.setState( { showDialog : true, deleteTile : geotile } )
  }

  onCancelDelete = () => {
    this.setState( { showDialog : false, deleteTile : null } )
  }

  onDeleteGeotile = () => {
    const { dispatch, projectId } = this.props
    const { deleteTile : { id : geotileId } } = this.state
    dispatch( GeotileActions.deleteGeotile( { projectId, geotileId } ) )
    this.setState( { showDialog : false, deleteTile : null } )
  }

  renderTiles = () => {
    const { geotiles = [] } = this.props
    return geotiles.map( geotile => (
      <GeotileThumbnail 
        onDelete={this.onDeleteClick} 
        onClick={this.onClickTile} 
        key={geotile?.id} 
        geotile={geotile} />
    ) )
  }

  render() {
    const { status } = this.props
    if ( status === 'loading' ) {
      const cn = classnames( 'fa fa-spin fa-refresh fa-fw' )
      return (
        <Flex justify="center" align="center" className={style.loader}>
          <Flex direction="column">
            <Text>Loading Geotiles...</Text>
            <i className={cn} />
          </Flex>
        </Flex>
      )
    }
    const { showDialog, deleteTile } = this.state
    const geotiles = this.renderTiles()
    return (
      <div>
        <YesNoDialog show={showDialog}
          bsSize="large"
          title="Delete Geotile?"
          yes="Delete"
          no="Cancel"
          onYes={this.onDeleteGeotile}
          onNo={this.onCancelDelete}
          message={`Delete Geotile ${deleteTile?.name || deleteTile?.id}?`} />
        <Screen className={style.screen}>
          <Screen.Header className={style.header}>
            <h4 className="headerLabel">Geotiles</h4>
            <span>
              <Button bsStyle="primary"
                className="add-button"
                onClick={this.onCreateTile}> 
                <i className="fa fa-fw fa-circle-plus fa-lg" />
                {' '}
                New Tile
              </Button>
            </span>
          </Screen.Header>
          <Screen.Content>
            <section className={style.thumbnails}>
              {geotiles}
            </section>
          </Screen.Content>
        </Screen>
      </div>
    )
  }
}

export default connect( ( state, props ) => {
  const { match : { params : { projectId } } } = props
  return {
    projectId,
    geotiles : state.geotiles.geotiles,
    status : state.geotiles.status
  }
}
)( GeotilesScreen )
